import { checkIsAdmin } from '~/permissions/checkIsAdmin';

import { RoutePathType } from '../enums';
import { RouteResolver } from '../types';

/**
 * This creates the default resolvers for admin routes:
 * - Provides the component to resolve to if user passes the permission checkIsAdmin.
 * - Redirects to RoutePathType.Home otherwise
 */
export const createAdminResolvers = (
  component: React.ComponentType<any>,
): RouteResolver[] => {
  return [
    {
      permission: checkIsAdmin,
      component,
    },
    {
      redirectPath: RoutePathType.Home,
    },
  ];
};
